import { render, staticRenderFns } from "./RemoveLeaveReasonModal.vue?vue&type=template&id=376a9fdc&"
import script from "./RemoveLeaveReasonModal.vue?vue&type=script&lang=js&"
export * from "./RemoveLeaveReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports